import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { DSTLogo } from "@/components/dst-logo";
import { LocaleSwitcher } from "@/components/locale-switcher";
import { LoginModal } from "@/components/modals/login-modal";
import { LogoutModal } from "@/components/modals/logout-modal";
import { useSession } from "@/hooks/use-session";
import { useSessionRedirect } from "@/hooks/use-session-redirect";
import { SOCIAL_MEDIA_LINKS } from "@/lib/constants";

export const Layout = () => {
  const { session } = useSession();
  useSessionRedirect();
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const organisation = session?.user?.organization;
  const profile = session?.user?.profile;
  let organisationName =
    organisation?.company_name ?? organisation?.dealer_name;

  if (!organisationName) {
    if (profile?.first_name) {
      organisationName = profile.last_name
        ? `${profile.first_name} ${profile.last_name}`
        : profile.first_name;
    } else {
      organisationName = "Dealer";
    }
  }

  return (
    <div className="bg-background">
      <header className="bg-primary">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-6 px-6">
          <a href="/">
            <DSTLogo className="h-10" variant="white" />
          </a>
          <div className="flex items-center gap-6">
            {session ? (
              <>
                <div className="text-sm text-white">
                  Welcome, {organisationName}
                </div>
                <LogoutModal />
              </>
            ) : (
              <LoginModal />
            )}
            <LocaleSwitcher />
          </div>
        </div>
      </header>

      <main className="mx-auto min-h-[calc(100vh-410px)] max-w-7xl px-6 py-10">
        <Outlet />
      </main>

      <footer>
        <div className="bg-muted">
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-center space-y-12 bg-accent px-6 py-20">
            <a className="" href="/">
              <DSTLogo className="h-12" size="lg" />
            </a>
            <div className="flex items-center gap-16">
              {SOCIAL_MEDIA_LINKS.map((link) => (
                <a
                  href={link.url}
                  key={link.label}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {/** biome-ignore lint/correctness/useImageSize: Based on width only */}
                  <img alt={link.label} src={link.icon} width={40} />
                </a>
              ))}
            </div>
          </div>
        </div>
        <div className="bg-primary">
          <div className="mx-auto flex w-full max-w-7xl flex-col-reverse items-center gap-4 px-6 py-4 font-light text-sm text-white sm:flex-row sm:items-center sm:justify-between">
            <p className="text-center sm:text-left">
              Copyright © {currentYear} Datastream Digital Sdn. Bhd. All rights
              reserved.
            </p>
            <div className="flex items-center gap-1">
              <a href="https://dst.com.bn/wp-content/uploads/2020/01/Master-Terms-and-Conditions-of-Services-22.1.2020.pdf">
                {t("labels.terms-and-conditions")}
              </a>
              |
              <a href="https://dst.com.bn/legal/">
                {t("labels.privacy-policy")}
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
